import PageContent from "../components/PageContent";
import LineChart from "../components/LineChart";
import { generateStaffData as dataGenerator } from "../util/genStaffData";
import classes from "./StaffPage.module.css";
import StaffRanking from "../components/StaffRanking";
import { getBranchInfobyId } from "../util/multipleBranch/getActiveBranchId";
// this dumy data i will have to extract from feedback forms. in this formate.

// this staff register is extracted from Staff Register in local storage.

export default function StaffPage() {
  const data1 = JSON.parse(sessionStorage.getItem("subData"));
  let timeRange = JSON.parse(sessionStorage.getItem("timeRange"));
  const data = dataGenerator(timeRange, data1);
  console.log(data1);
  console.log(timeRange);
  console.log(data);
  // this data is used for line chart as well has Ranking of staff.
  let branches = JSON.parse(localStorage.getItem("branches"));
  return (
    <>
      <PageContent>
        <h3>Staff Review Page</h3>
        {data ? (
          <div className={classes.container}>
            <div className={classes.subContainer}>
              <h3>Staff Performance</h3>
              <p>({timeRange} days)</p>

              <div className={classes.chartContainer}>
                {data.map((d, index) => {
                  return (
                    <div
                      key={`${index}gll`}
                      className={classes.branchContainer}
                    >
                      {branches.length > 1 && (
                        <h4>{getBranchInfobyId(d.bId).name}</h4>
                      )}
                      <LineChart data={d.data[0]} />
                    </div>
                  );
                })}
              </div>
            </div>
            <div className={classes.subContainer}>
              <h3>Staff Ranking</h3>

              <div className={classes.chartContainer}>
                {data.map((d, index) => {
                  return (
                    <div
                      key={`${index}gll`}
                      className={classes.branchContainer}
                    >
                      {branches.length > 1 && (
                        <h4>{getBranchInfobyId(d.bId).name}</h4>
                      )}
                      <StaffRanking data={d.tableData} />
                    </div>
                  );
                })}
              </div>
            </div>
            {/* <div className={classes.subContainer}>
              <h3>Staff Rankings</h3>
              <StaffRanking data={data} />
            </div> */}

            <br />
            <br />
          </div>
        ) : (
          <>
            <h3>No data</h3>
          </>
        )}
      </PageContent>
    </>
  );
}
